import React from 'react';
import { change, Field, reduxForm } from 'redux-form';
import { connect, useDispatch } from 'react-redux'
import { Input, Checkbox, Value } from '../form/'
import * as $ from 'jquery'
import FindingSetting from '../authorised/impressionFinding/settings/FindingSetting';

let FormTemplateFields = props => {
  const { baseName, isVisible, isRequired, hideIsRequired, isModeOfNotificationDefaultVal, defaultValueReadOnly, defaultValueDisabled, showFindingField, isFindingSupport, radioOptions, examTemplateFormValues, form, dispatch } = props;


  const toggleVisibility = () => {
    dispatch(
      change(
        form,
        `${baseName}[visible]`,
        !isVisible
      )
    );
  };
  $(".dropdown-menu .custom-checkbox").click(function (e) {
    e.stopPropagation();
  })

  return (
    <>
      <span className="FormTemplateFields label-customisation d-flex justify-content-between">
        <div className="d-flex justify-content-start">
          <Field name={baseName + '[custom_label]'} label="" component={Value} />
          {isRequired && <span className="text-danger pl-2"> *</span>}
        </div>
        <div className="d-flex justify-content-end">
          {((showFindingField || process.env.REACT_APP_SUITE_NAME == "OWNER-SUITE") && isFindingSupport) && <FindingSetting baseName={baseName} isVisible={isVisible} />}
          <span>
            <i
              className={`la mr-3 ${isVisible ? 'la-eye text-muted' : 'la-eye-slash text-muted'}`}
              style={{
                cursor: 'pointer',
                opacity: isVisible ? 1 : 0.4
              }}
              onClick={toggleVisibility}
            />

            <Field
              name={`${baseName}[visible]`}
              label=""
              component={Checkbox}
              className="d-none"
              wrapperClasses="d-none"
            />
          </span>
          <span className={`btn p-0 ${isVisible ? '' : 'd-none'}`} id={baseName} data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i className="la la-pencil text-muted" />
          </span>
          <div id="label-customisation" className="dropdown-menu dropdown-menu-right border-0 shadow mt-7 ml-3" aria-labelledby={baseName}>
            <div className="row px-7 pb-5">
              <button type="button" className="close m-0 w-100 text-right" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <Field name={baseName + '[default_label]'} label="Default Label" component={Input} disabled={true} className="form-control" wrapperClasses="col-12 form-group" />
              <Field name={baseName + '[custom_label]'} label="New Label" component={Input} className="form-control" wrapperClasses="col-12 form-group" />
              <Field name={baseName + '[default_value]'} label="Default Value" component={Input} className="form-control" wrapperClasses="col-12 form-group" isModeOfNotificationDefaultVal={isModeOfNotificationDefaultVal} readOnly={defaultValueReadOnly} disabled={defaultValueDisabled} />
              {!hideIsRequired && <Field name={baseName + '[required]'} label="Is required?" component={Checkbox} className="form-control" wrapperClasses="col-12 form-group ch" />}
            </div>
          </div>
        </div>
      </span>

      {radioOptions && radioOptions.length > 0 && (
        <div className="mt-2 pl-3 border-left ml-2">
          {radioOptions.map((opt) => {
            const optBaseName = opt.optBaseName || `${baseName}[options][${opt.value}]`;
            const optId = opt.optBaseName ? `${opt.optBaseName}-opt` : `${baseName}-opt-${opt.value}`;
            let val = {};

            try {
              const pathParts = optBaseName
                .replace(/\[/g, '.')
                .replace(/\]/g, '')
                .split('.');

              val = examTemplateFormValues;

              for (const part of pathParts) {
                val = val && val[part];
              }
            } catch (e) {
              val = {};
            }

            const visible = val?.visible ?? true;
            const customLabel = val?.custom_label || opt.label;

            return (
              <span key={opt.value} className="FormTemplateFields label-customisation d-flex justify-content-between align-items-center py-1">
                <span
                  className="small d-flex align-items-center"
                  style={{
                    opacity: visible ? 1 : 0.4,
                    color: visible ? 'inherit' : '#6c757d'
                  }}
                >
                  <i className="la la-circle-o mr-1" style={{ fontSize: '0.7rem' }} />
                  {customLabel}
                </span>

                <span className="d-flex align-items-center">
                  <i
                    className={`la mr-2 ${
                      /* determine current visible value */
                      visible ? 'la-eye' : 'la-eye-slash'
                      }`}
                    style={{
                      cursor: 'pointer',
                      opacity: visible ? 1 : 0.4,
                    }}
                    onClick={() =>
                      dispatch(
                        change(
                          form,
                          `${optBaseName}[visible]`,
                          !visible
                        )
                      )
                    }
                  />

                  <Field
                    name={`${optBaseName}[visible]`}
                    component={Checkbox}
                    className="d-none"
                    wrapperClasses="d-none"
                  />

                  {/* Pencil → dropdown to edit label */}
                  {visible && (
                    <span
                      className="btn p-0"
                      id={optId}
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i className="la la-pencil text-muted" />
                    </span>
                  )}
                  <div className="dropdown-menu dropdown-menu-right border-0 shadow mt-7 ml-3" aria-labelledby={optId}>
                    <div className="row px-7 pb-5">
                      <button type="button" className="close m-0 w-100 text-right" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                      <div className="col-12 form-group">
                        <label>Default Label</label>
                        <input
                          type="text"
                          className="form-control"
                          value={opt.label}
                          disabled
                          readOnly
                        />
                      </div>
                      <Field
                        name={`${optBaseName}[custom_label]`}
                        label="New Label"
                        component={Input}
                        className="form-control"
                        wrapperClasses="col-12 form-group"
                      />
                    </div>
                  </div>
                </span>
              </span>
            );
          })}
        </div>
      )}
    </>
  )
}
reduxForm({
  form: 'examTemplateForm'
})(FormTemplateFields);

const mapStateToProps = (state) => {
  const { setting: { orgConfig } } = state
  const examTemplateFormValues = state.form && state.form.examTemplateForm && state.form.examTemplateForm.values
  return {
    showFindingField: orgConfig.org_config?.exam_settings?.auto_diagnosis,
    examTemplateFormValues: examTemplateFormValues || {},
  }
}

export default connect(mapStateToProps)(FormTemplateFields);